import { apiWithBody, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ApiDef_PermissionUser, DBDef_PermissionUser } from '@nu-art/permissions-shared';
export const dispatch_onPermissionUserChanged = new ThunderDispatcherV3('__onPermissionUserUpdated');
export class ModuleFE_PermissionUser_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_PermissionUser, dispatch_onPermissionUserChanged);
        this._v1 = {
            assignPermissions: apiWithBody(ApiDef_PermissionUser._v1.assignPermissions),
        };
    }
}
export const ModuleFE_PermissionUser = new ModuleFE_PermissionUser_Class();
//# sourceMappingURL=ModuleFE_PermissionUser.js.map